var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTugoLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 225 218.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f3e1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.96,55.66l-11.62,11.62,57.13,57.13-16.29,16.29L25.05,83.57l-10.9,10.9L0,80.31,38.81,41.5l14.16,14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.53,20.77l53.47,53.46c2.44,2.45,4.38,2.34,5.6,1.12,1.22-1.22,1.32-3.16-1.12-5.6L64.01,16.29,80.31,0l52.14,52.14c12.32,12.32,11.71,25.97,0,37.68-11.61,11.61-24.64,11.81-37.07-.61L43.24,37.07l16.29-16.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.1,147.2c-2.34,2.34-1.83,5.1-.61,6.32,1.32,1.32,4.13,1.48,6.98-1.37l11.51-11.51-2.99-2.99,10.59-10.59,18.41,18.41-39.41,39.41-11.1-11.1,6.41-6.41-1.12-1.12c-6.11,3.46-13.44,1.43-18.23-3.36-6.82-6.82-8.86-19.86,4.48-33.2l35.85-35.85c12.42-12.42,25.46-11.81,37.06-.2,11.71,11.71,12.43,25.46,.31,37.57l-9.77,9.77-15.25-15.25,10.89-10.89c2.55-2.55,2.05-4.87,.83-6.1-1.32-1.32-4.11-2.28-6.66,.27l-38.19,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.92,135.63c11.71,11.71,12.42,25.46,.2,37.68l-35.74,35.74c-12.32,12.32-26.07,11.61-37.78-.1-11.61-11.61-12.02-24.85,.41-37.27l35.74-35.74c12.42-12.42,25.56-11.91,37.17-.31Zm-57.94,53.66c-2.44,2.44-2.24,4.48-1.02,5.7,1.32,1.32,3.36,1.53,5.8-.92l38.29-38.29c2.55-2.55,2.24-4.48,.92-5.8-1.22-1.22-3.16-1.53-5.7,1.02l-38.29,38.29Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTugoLogoLight);
export default __webpack_public_path__ + "static/media/tugo-logo-light.2267711e31095f1c78c306ba58f319f0.svg";
export { ForwardRef as ReactComponent };